module.exports = __webpack_public_path__ + "zip/origfac42x9.zip";